import { Select } from "../../ui";

export interface PersonaVariableOption {
  id: string;
  label: string;
}

export interface PersonaVariableScopeSelectProps {
  onChange: (personaId: string) => void;
  options: PersonaVariableOption[];
  value: string;
}

// Persona-variable authoring stays isolated from the already-large
// PersonasList. Both the Variables route and declaration-by-use consume this
// small generated-id picker without adding variable logic to the Persona list.
export function PersonaVariableScopeSelect({
  onChange,
  options,
  value,
}: PersonaVariableScopeSelectProps) {
  return (
    <Select
      label="Persona"
      required
      value={value}
      onChange={(event) => {
        onChange(event.currentTarget.value);
      }}
    >
      <option disabled value="">
        Select a Persona
      </option>
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </Select>
  );
}
